import { render } from "./GamePlay.vue?vue&type=template&id=109fb9b8&scoped=true"
import script from "./GamePlay.vue?vue&type=script&lang=js"
export * from "./GamePlay.vue?vue&type=script&lang=js"

import "./GamePlay.vue?vue&type=style&index=0&id=109fb9b8&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10000-sdk\\client\\web\\hzplatform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109fb9b8"]])

export default __exports__